import { IconButton, SxProps, TextField, Theme } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useFormContext, useWatch } from "react-hook-form";
import Grid2 from "@mui/material/Unstable_Grid2";
import { SyntheticEvent } from "react";

interface AmountSelectorProps {
    formName: string;
    initValue?: number;
    maxValue?: number;
    sx?: SxProps<Theme>;
}

export default function AmountSelector({ formName, initValue = 0, maxValue = 10, sx }: AmountSelectorProps) {
    const { register, getValues, setValue, control } = useFormContext();

    const currentVal = useWatch({ control, defaultValue: initValue, name: formName });

    const increaseAmount = () => {
        const currentVal: number = getValues(formName);
        if (currentVal < maxValue) {
            setValue(formName, currentVal + 1);
        }
    }

    const decreaseAmount = () => {
        const currentVal: number = getValues(formName);
        if (currentVal > 0) {
            setValue(formName, currentVal - 1);
        }
    }

    return (
        <Grid2 sx={sx} container columns={6} alignItems="center" direction='row'>
            <Grid2 xs={2}>
                <IconButton aria-label="remove" onClick={decreaseAmount} disabled={currentVal <= 0}>
                    <RemoveIcon />
                </IconButton>
            </Grid2>
            <Grid2 xs={2}>
                <TextField
                    type="number"
                    size="small"
                    variant="standard"
                    {...register(formName, {
                        valueAsNumber: true,
                        max: maxValue,
                        min: 0,
                        onChange: (event) => {
                            if (event.target.value > maxValue) {
                                setValue(formName, maxValue);
                            }
                        },
                        value: initValue
                    })} />
            </Grid2>
            <Grid2 xs={2}>
                <IconButton aria-label="add" onClick={increaseAmount} disabled={currentVal >= maxValue}>
                    <AddIcon />
                </IconButton>
            </Grid2>
        </Grid2>
    );
}